import * as React from 'react';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';


interface Props {
    readonly open: boolean,
    readonly titleKey: string,
    readonly labelKey: string,
    readonly text: string,
    readonly onDialogCancel: () => void,
    readonly onDialogSubmit: () => void,
    readonly onTextChanged: (text: string) => void,
}


const TextFieldDialogView = ({open, titleKey, labelKey, text, intl, onDialogCancel, onDialogSubmit, onTextChanged}: Props & InjectedIntlProps) => {

    return (
        <Dialog open={open} fullWidth={true} onClose={onDialogCancel}>
            <DialogTitle>
                <FormattedMessage id={titleKey}/>
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus={true}
                    label={intl.formatMessage({id: labelKey})}
                    value={text}
                    onChange={e => onTextChanged(e.target.value)}
                    margin="normal"
                    multiline={true}
                    fullWidth={true}
                    rows={8}
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onDialogCancel} color="default">
                    <FormattedMessage id="cancel"/>
                </Button>
                <Button onClick={onDialogSubmit} color="primary">
                    <FormattedMessage id="ok"/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default injectIntl(TextFieldDialogView);


// WEBPACK FOOTER //
// ./src/components/TextFieldDialogView.tsx